import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { getPriceDisplay } from '../../../../../modules/catalog/services/catalog';
import { MenuConsumer } from '../../../FoodMenu.context';
import MenuUtil from '../../../utils/menu';
var defaultProps = {
  displayZeroCostModifierPrices: false
};
export default function ModifierSetBasic(_ref) {
  var modifierSetId = _ref.modifierSetId,
    displayZeroCostModifierPrices = _ref.displayZeroCostModifierPrices;
  return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var modifierSets = _ref2.modifierSets,
      modifiers = _ref2.modifiers,
      precision = _ref2.precision;
    var modifierSet = MenuUtil.getModifierSetById(modifierSets, modifierSetId);
    var modifierSetModifierIds = modifierSet.modifiers;
    var modifierSetModifiers = MenuUtil.getModifierSetModifiers(modifierSetModifierIds, modifiers);
    return /*#__PURE__*/React.createElement("div", {
      className: "fcfm-modifier-set"
    }, /*#__PURE__*/React.createElement("h6", null, modifierSet.name), /*#__PURE__*/React.createElement("ul", null, modifierSetModifiers.map(function (_ref3) {
      var name = _ref3.name,
        price = _ref3.price;
      var finalPrice = getPriceDisplay(price, {
        displayZeroCost: displayZeroCostModifierPrices,
        precision: precision
      });
      return /*#__PURE__*/React.createElement("li", {
        key: name
      }, name, !_isEmpty(finalPrice) && ": ".concat(finalPrice));
    })));
  });
}
ModifierSetBasic.defaultProps = defaultProps;